import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoute = ({ children }) => {
  const location=useLocation();
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);

  if (logged && logged) {
    // user is not authenticated
    return children;
  } else {
    return <Navigate to="/" replace state={{from:location.pathname+location.hash}} />;
  }
};
